module.exports = __webpack_public_path__ + "static/img/3.dcf5238.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/3.png
// module id = 3tiS
// module chunks = 4